<script setup lang="ts">
import Header from "~/components/layout/Header.vue";
import Discord from "~/components/layout/Discord.vue";
import Footer from "~/components/layout/Footer.vue";
import Spotify from "~/components/layout/Spotify.vue";
import Newsletter from "~/components/layout/Newsletter.vue";
import Promotion from "~/components/layout/Promotion.vue";
import NewsletterButton from "~/components/layout/NewsletterButton.vue";
// import Announcement from "../components/layout/Announcement.vue";
import { onMounted, ref } from 'vue';

const isNewsletterOpen = ref(false);

const promotionsResponse = await GqlGetPromotions();

const promotions = promotionsResponse.promotions;

onMounted(() => {
  const injectScript = document.createElement('script');
  injectScript.src = "https://cdn.botpress.cloud/webchat/v3.6/inject.js";
  injectScript.async = true;
  document.body.appendChild(injectScript);

  const configScript = document.createElement('script');
  configScript.src = "https://files.bpcontent.cloud/2026/03/28/09/20260328092537-IESBR0C1.js";
  configScript.defer = true;
  document.body.appendChild(configScript);

  // Wait for the config script to load before setting up listeners
  configScript.onload = () => {
    if (window.botpress) {
      window.botpress.on('webchat:ready', () => {
        window.botpress.sendMessage("Hi!")
      })
    }
  };
});

</script>

<template>
    <div class="sticky top-0 z-10">
        <Header />
        <Promotion class="max-sm:hidden block" v-if="promotions.length && promotions[0].active" :promotion="promotions[0]"/>
<!--        <Announcement class="max-sm:hidden block"/>-->
    </div>

    <Promotion class="sm:hidden" v-if="promotions.length && promotions[0].active" :promotion="promotions[0]"/>
<!--    <Announcement class="sm:hidden"/>-->

    <NuxtPage class="z-0"/>

    <Spotify/>
    <Discord/>
    <Newsletter @subscribe="isNewsletterOpen = true"/>
    <Footer/>
    <NewsletterButton v-model:open="isNewsletterOpen"/>
</template>

<style>
body {
    font-family: "Barlow Semi Condensed";
    width: 100%;
    overflow-x: hidden;
}

/* Prevent content from extending beyond screen width */
* {
    max-width: 100vw;
}

/* Ensure main content container respects viewport width */
#__nuxt {
    max-width: 100vw;
    overflow-x: hidden;
}

/* Common utility to prevent horizontal scroll */
.nuxt-layout-container {
    max-width: 100%;
    overflow-x: clip;
}

/* Ensure images don't exceed viewport width */
img {
    max-width: 100%;
}

/* Prevent text from overflowing container */
p, span, div, section, article, header, footer, nav {
    max-width: 100vw;
}
</style>
